import { Color } from '@eggplant/pattern-library'

const SelectGitSuiteInfo = () =>
  <span>
    <Color variant='theme-color-statuschip-text'>
      <strong>Why don't I see some of my suites in the list?</strong>
    </Color>
    <br />
    <Color variant='form-alert-text-color'>
      You will not see a suite listed in the dropdown if you already have a suite uploaded to DAI with the same name. Either delete the existing suite within DAI or rename the suite listed within your repository.
    </Color>
  </span>

export default SelectGitSuiteInfo
